import {
  GET_AMBASSADOR_BY_ID_GRAPH_QL,
  GET_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS,
  GET_AMBASSADOR_BY_ID_GRAPH_QL_FAILURE,
  GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL,
  GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_SUCCESS,
  GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_FAILURE,
} from './const'
import createMiddleware from 'Reducers/createMiddleware'
import { getAmbassador, getAmbassadorsList } from '../../Module/graphQL'

/**
 * Get brand ambassador profile item middleware
 */
export const getBrandAmbassadorProfileMiddleware = createMiddleware({
  actions: [
    GET_AMBASSADOR_BY_ID_GRAPH_QL,
    GET_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS,
    GET_AMBASSADOR_BY_ID_GRAPH_QL_FAILURE,
  ],
  fetchMethod: (authToken, payload) => getAmbassador(authToken, payload),
})

export const getBrandAmbassadorProfilesListMiddleware = createMiddleware({
  actions: [
    GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL,
    GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_SUCCESS,
    GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_FAILURE,
  ],
  fetchMethod: (authToken, payload) => getAmbassadorsList(authToken, payload),
})
